import { makeRequest } from "../../baseApi";
import { convertAbbreviations, convertBook, convertBooks } from "./utils";
import { makeBooksDownloadCancelTokenKey } from "./constants";
import { parseResponseDefault } from "../../not-sorted.utils";
import { makeFolderCacheName } from "@/shared/api/content/languages/utils";
import { getBookIdNumber, makeChapterTree } from "@/shared/utils/content/content";
import { CONTENT_MEMORY_CACHE_TIME } from "@/shared/api/constants";

export const fetchDownloadBook = (book, onDownloadProgress, onCancel) => {
  return makeRequest({
    url: book.download,
    type: "get",
    responseType: "blob",
    parseResponse: parseResponseDefault,
    onDownloadProgress,
    onCancel,
    cancelTokenKey: makeBooksDownloadCancelTokenKey(book.book_id),
  });
};

export const getAbbreviationsRequest = () => {
  const request = {
    url: "/content/books/abbreviations",
    type: "GET",
    parseResponse: (response) => convertAbbreviations(response.data)
  };
  return makeRequest(request);
};

export const getBiblesAllLangsRequest = () =>
  makeRequest({
    url: "/content/books?type=bible",
    storageCacheName: makeFolderCacheName("bibles"),
    parseResponse: (response) => convertBooks(response.data.results),
  });

export const getSGBooksRequest = () =>
  makeRequest({
    url: "/content/books?search=" + encodeURIComponent("Study Guide"),
    storageCacheName: makeFolderCacheName("studyGuide"),
    parseResponse: (response) => convertBooks(response.data.results),
  });

export const getFolderBooksRequest = (id) =>
  makeRequest({
    url: `/content/books/by_folder/${id}`,
    storageCacheName: makeFolderCacheName(id),
    parseResponse: (response) => convertBooks(response.data),
  });

export const getBookByIdRequest = async (id) => {
  const realId = getBookIdNumber(id);
  const bookData = await makeRequest({
    url: `content/books/${realId}`,
    memoryCache: true,
    memoryCacheTime: CONTENT_MEMORY_CACHE_TIME,
    parseResponse: (response) => convertBook(response.data),
  });
  if (bookData?.id !== id) {
    return undefined;
  }
  return bookData;
};

export const getBookTocById = (bookIdOrigin) => {
  return makeRequest({
    url: `content/books/${bookIdOrigin}/toc`,
    memoryCache: true,
    memoryCacheTime: CONTENT_MEMORY_CACHE_TIME,
    parseResponse: (response) => makeChapterTree(response.data),
  });
};

const _getBooksRequest = async (ids) => {
  const args = ids.map((item) => "pubnr=" + item).join("&");
  return makeRequest({
    url: `content/books?${args}`,
    type: "get",
    memoryCache: true,
    memoryCacheTime: CONTENT_MEMORY_CACHE_TIME,
    parseResponse: (response) => convertBooks(response.data.results),
  });
};

// Workaround for loading big amount of books.
export const getBooksRequest = async (bookIds) => {
  const allList = [];
  const ids = [...bookIds];

  while (ids.length !== 0) {
    const partIds = ids.splice(0, 100);
    const books = await _getBooksRequest(partIds);
    if (books) {
      allList.push(...books);
    }
  }

  return allList;
};
